import { render, staticRenderFns } from "./CalcsMenu.vue?vue&type=template&id=dce9c7e4&scoped=true&"
import script from "./CalcsMenu.vue?vue&type=script&lang=js&"
export * from "./CalcsMenu.vue?vue&type=script&lang=js&"
import style0 from "./CalcsMenu.vue?vue&type=style&index=0&id=dce9c7e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce9c7e4",
  null
  
)

export default component.exports